// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"style__iconWrapper__AZWUR","icon":"style__icon__H1A2v"};